<div class="modal-form">
  <div class="card form-modal" style="min-width: 400px">
    <div class="card-header">
     <h4>{{item.titulo}}</h4>
      <div class="close-button" (click)="close()">
        x
      </div>
    </div>
    <div class="card-body">
      <div class="form-group row">
        <label class="col-3 col-form-label" for="nombre">Nombre</label>
        <div class="col-9">
          <input type="text" class="form-control" id="nombre" (keyup.enter)="success()"
                 [(ngModel)]="nombre" placeholder="Ingrese el nombre">
        </div>
      </div>
      <button class="btn" (click)="close()" style="margin-right: 10px">Cancelar</button>
      <button [disabled]="nombre == nombre_validar" class="btn" (click)="success()">Guardar
      </button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/modal-grupo/modal-grupo.component.html